"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const mark_common_1 = require("@gojipress/mark-common");
const katex_1 = __importDefault(require("katex"));
const latexInlinePlugin = {
    name: "LaTeX Inline HTML Renderer",
    pluginType: "renderer",
    types: [mark_common_1.GMType.LatexInline],
    render: node => {
        const span = document.createElement("span");
        span.classList.add('gmLatexInline');
        if (node.children.length > 0) {
            const content = node.children[0].original;
            katex_1.default.render(content, span, {
                throwOnError: false,
                output: "mathml",
            });
        }
        return [
            [{
                    element: span,
                }],
            undefined,
        ];
    }
};
exports.default = latexInlinePlugin;
